<template>
  <v-menu
    offset-y
    left
    min-width="160"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        icon
        class="app-bar-icon-btn"
        v-bind="attrs"
        :aria-label="$t('languageSelector.label')"
        v-on="on"
      >
        <v-icon>translate</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-for="lang in languages"
        :key="lang.code"
        :input-value="$i18n.locale === lang.code"
        @click="setLocale(lang.code)"
      >
        <v-list-item-title>{{ lang.label }}</v-list-item-title>
        <v-list-item-action v-if="$i18n.locale === lang.code">
          <v-icon small color="primary">check</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script lang="ts">
    import Vue from 'vue';
    import {persistLocale} from '@/plugins/I18n';

    export default Vue.extend({
        name: 'LanguageSelector',
        computed: {
            languages(): Array<{code: string; label: string}> {
                return (this.$i18n.availableLocales || ['cs', 'en']).map((code: string) => ({
                    code,
                    label: String(this.$t(`languageSelector.${code}`)),
                }));
            },
        },
        watch: {
            '$i18n.locale': function (newLocale): void {
                this.applyLocale(newLocale);
            }
        },
        created: function () {
            this.applyLocale(this.$i18n.locale);
        },
        methods: {
            setLocale(locale: string): void {
                this.$i18n.locale = locale;
            },
            applyLocale(locale: string): void {
                // @ts-ignore
                this.$moment.locale(locale);
                this.$vuetify.lang.current = locale;
                persistLocale(locale);
            },
        }
    });

</script>

<style scoped>
</style>
